var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17660_18430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.66675C0 4.24847 3.58172 0.666748 8 0.666748C12.4183 0.666748 16 4.24847 16 8.66675C16 13.085 12.4183 16.6667 8 16.6667C3.58172 16.6667 0 13.085 0 8.66675Z",
    fill: "#DEEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 8.66675C0.75 4.66268 3.99594 1.41675 8 1.41675C12.0041 1.41675 15.25 4.66268 15.25 8.66675C15.25 12.6708 12.0041 15.9167 8 15.9167C3.99594 15.9167 0.75 12.6708 0.75 8.66675Z",
    fill: "#708FFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 8.66675C0.75 4.66268 3.99594 1.41675 8 1.41675C12.0041 1.41675 15.25 4.66268 15.25 8.66675C15.25 12.6708 12.0041 15.9167 8 15.9167C3.99594 15.9167 0.75 12.6708 0.75 8.66675Z",
    stroke: "#708FFB",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3977 5.59348L6.62434 10.2001L5.35767 8.84681C5.12434 8.62681 4.75767 8.61348 4.491 8.80015C4.231 8.99348 4.15767 9.33348 4.31767 9.60681L5.81767 12.0468C5.96434 12.2735 6.21767 12.4135 6.50434 12.4135C6.77767 12.4135 7.03767 12.2735 7.18434 12.0468C7.42434 11.7335 12.0043 6.27348 12.0043 6.27348C12.6043 5.66015 11.8777 5.12015 11.3977 5.58681V5.59348Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17660_18430"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.66675C0 4.24847 3.58172 0.666748 8 0.666748C12.4183 0.666748 16 4.24847 16 8.66675C16 13.085 12.4183 16.6667 8 16.6667C3.58172 16.6667 0 13.085 0 8.66675Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.b2071fa69ed541f40a86b4ddc13bce81.svg";
export { ForwardRef as ReactComponent };